import { useEffect } from "react";
import styled from "styled-components";

const Wrapper = styled.section`
    background: #14315b;
    -webkit-box-sizing: inherit;
    box-sizing: inherit;
    z-index: -1;
`;

const ElfsightWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <Wrapper>
      <div className="elfsight-app-c84b6398-6db4-4910-bc64-5f68a18a0c50" data-elfsight-app-lazy></div>
    </Wrapper>
  ); // replace with your actual widget ID
};

export default ElfsightWidget;
